<template>
  <div class="school-new-goal-banner">
    <h5><span>90% скидка</span> на&nbsp;первый месяц обучения</h5>
    <h6>попробуйте семейное обучение на выгодных условиях</h6>
    <button
      class="main-banner__btn m-btn"
      @click="openModal(MODAL_TYPES.discount)"
    >
      оставить заявку
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../../common/AppHeader/data';

export default {
  name: 'OtherSchoolGoalBanner',
  data: () => ({
    MODAL_TYPES,
  }),
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style scoped lang="scss">

.school-new-goal-banner {
  height: calc(var(--scale) * 350);
  position: relative;
  padding: calc(var(--scale) * 24) calc(var(--scale) * 40) calc(var(--scale) * 40);
  border-radius: calc(var(--scale) * 60);
  background-image: url("/v2/school-new/other-pages/goal-banner/banner.webp");
  background-size: 100% 100%;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 140 );
    padding: calc(var(--scale) * 10) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 24);
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 366);
    padding: calc(var(--scale) * 12) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/school-new/other-pages/goal-banner/banner-mob.webp");
  }

  h5 {
    max-width: calc(var(--scale) * 1024 );
    margin-bottom: calc(var(--scale) * 12);

    font-weight: 500;
    font-size: calc(var(--scale) * 80);
    line-height: 90%;
    letter-spacing: -0.04em;
    color: #221A4C;

    span {
      color: #5237E6;
    }

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 410);
      font-size: calc(var(--scale) * 32);
      margin-bottom: calc(var(--scale) * 5);
    }

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 38);
    }
  }

  h6 {
    max-width: calc(var(--scale) * 635);
    font-weight: 500;
    font-size: calc(var(--scale) * 40);
    line-height: 100%;
    letter-spacing: -0.02em;
    color: #092A48;

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 254);
      font-size: calc(var(--scale) * 16);
    }

    @include media-down($size-mobile) {
      max-width: calc(var(--scale) * 270);
      font-size: calc(var(--scale) * 18);
    }
  }

  button {
    padding: calc(var(--scale) * 34) calc(var(--scale) * 56);
    position: absolute;
    right: calc(var(--scale) * 40);
    bottom: calc(var(--scale) * 40);
    background-color: #FF5319;
    border-radius: calc(var(--scale) * 24);

    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 14) calc(var(--scale) * 22);
      right: calc(var(--scale) * 16);
      bottom: calc(var(--scale) * 16);
      border-radius: calc(var(--scale) * 16);
      font-size: calc(var(--scale) * 18);
      line-height: 110%;
      letter-spacing: -0.02em;
    }

    @include media-down($size-mobile) {
      right: auto;
      left: calc(var(--scale) * 16);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }
  }
}

</style>
